import React from 'react'

export const Error = ({ children }) => (
  <div>ERROR!{children ? ` :${children}` : ''}</div>
)
export default Error
